import { Component,Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from '../../../../services/snackbar.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { DeclarationCampaignDialogComponent } from '../declaration-campaign-dialog/declaration-campaign-dialog.component';
import { Combo, ComboService } from '../../../../services/combo.service';
import {
  CampanacontrollerService,
  CampanaFilterDTO,
  CampanaDTO,
  DiccionarioControllerService,
  DiccionarioElementoDTO
} from 'api-rest';
import { DatePipe } from '@angular/common';
import { DeclarationCampaignErrorsComponent } from '../declaration-campaign-errors/declaration-campaign-errors.component';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';


@Component({
  selector: 'lib-declaration-campaign-search',
  templateUrl: './declaration-campaign-search.component.html',
  styleUrls: ['./declaration-campaign-search.component.scss']
})
export class DeclarationCampaignSearchComponent {
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;

  headArrayModificado: any[] = [];
  headArray: any = [
    {
      Head: 'Id',
      FieldName: 'id',
    },
    {
      Head: 'Año',
      FieldName: 'anio',
    },
    {
      Head: 'Descripción',
      FieldName: 'descripcion',
    },
    {
      Head: 'Fecha inicio',
      FieldName: 'fechaInicio',
      renderValue: (item: any) => this.datePipe.transform(item.fechaInicio, 'dd/MM/yyyy HH:mm'),
    },
    {
      Head: 'Fecha fin',
      FieldName: 'fechaFinalizacion',
      renderValue: (item: any) => this.datePipe.transform(item.fechaFinalizacion, 'dd/MM/yyyy HH:mm'),
    },
    {
      Head: 'Usuario',
      FieldName: 'creadoPor',
    },
    {
      Head: 'Fecha inicio lanzamiento',
      FieldName: 'fechaInicioEjecucion',
      renderValue: (item: any) => this.datePipe.transform(item.fechaInicioEjecucion, 'dd/MM/yyyy HH:mm'),
    },
    {
      Head: 'Fecha fin lanzamiento',
      FieldName: 'fechaFinEjecucion',
      renderValue: (item: any) => this.datePipe.transform(item.fechaFinEjecucion, 'dd/MM/yyyy HH:mm'),
    },
    {
      Head: 'Estado',
      FieldName: 'estado',
      Attribute: 'descripcion',
    },
    {
      Head: 'Fecha inicio corrección',
      FieldName: 'fechaInicioCorrecion',
      renderValue: (item: any) => this.datePipe.transform(item.fechaInicioCorrecion, 'dd/MM/yyyy HH:mm'),
    },
    {
      Head: 'Fecha fin corrección',
      FieldName: 'fechaFinCorrecion',
      renderValue: (item: any) => this.datePipe.transform(item.fechaFinCorrecion, 'dd/MM/yyyy HH:mm'),
    },
    {
      Head: 'Tipo campaña',
      FieldName: 'tipo',
      renderValue: (item: any) => item?.tipo === 'DAE' ? 'Campaña DAE' : item?.tipo === 'CVFGestor' ? 'Campaña CVF Gestores' : 'Campaña CVF Poseedores',
    },
    {
      Head: 'Campaña de CVF gestor asociada',
      FieldName: 'campanaAsociada',
      Attribute: 'id'
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        { nameButton: 'view', icon: 'open_in_new', toolTip: 'Editar' },
        { nameButton: 'errors', icon: 'wysiwyg', toolTip: 'Errores' },
      ],
      width: '10',
      permanent: true,
    },
  ];

  errorButtonConfig = { 
      nameButton: 'errors', 
      icon: 'wysiwyg', 
      toolTip: 'Errores',
      permanent: true
  };

  gridArray: any[] = [];
  generateForm: FormGroup;
  tipoCampanias: Combo[] = [];

  //searchForm: FormGroup;
  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  totalElements: number = 0;
  totalSearch: number = 0;
  mostrarFiltros: boolean = true;
  orden: DiccionarioElementoDTO[] = [];
  constructor(
      private formBuilder: FormBuilder,
      public dialog: MatDialog,
      public spinnerSrv: SpinnerService,
      private comboService: ComboService,
      private snackBarSrv: SnackbarService,
      private datePipe: DatePipe,
      private campanaService: CampanacontrollerService,
    private diccionarioControllerService: DiccionarioControllerService,
        @Inject('EmpusaAuthenticationService')
      public authService: EmpusaAuthenticationService
    ) {
      this.generateForm = this.formBuilder.group({
        id: [{ value: null, disabled: false }],
        tipo: [{ value: null, disabled: false }],
        anio: [{ value: null, disabled: false }],
        descripcion: [{ value: null, disabled: false }],
        orden: [{ value: null, disabled: false }],
        tipoOrden: [{ value: null, disabled: false }],
      });
    }

  ngOnInit(): void {
    this.tipoCampanias = this.comboService.getComboTiposCampanias();
    this.comboOrden();
  }
  comboOrden() {
    this.diccionarioControllerService
      .listarElementos(['ORDEN_ADMIN_CAMPANAS_BUSQUEDA'])
      .subscribe((res) => (this.orden = res['ORDEN_ADMIN_CAMPANAS_BUSQUEDA']));
  }
  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.buscar();
    }
  }

  buscar(){
    this.modificarTablaTipoCampana();

    const { backendFilter, page, size, orden, tipoOrden } = this.getBackendFilter();
    this.campanaService.findAll6(backendFilter,{page: page, size: size, sort:['fechaInicio,desc']}, orden ?? undefined, tipoOrden ?? undefined)
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.flagSearch = data.datos?.length !== 0 ? true : false;
            this.gridArray = data.datos ?? [];
            this.recordsTotal = data.paginacion?.totalElements ?? 0;
            this.totalSearch = this.gridArray.length;
          }
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  modificarTablaTipoCampana() {
    const selectedType = this.generateForm.get('tipo')?.value?.id;

    const isDAE = selectedType === 'DAE';
    const isCVFGestor = selectedType === 'CVFGestor';
    const isCVFPoseedor = selectedType === 'CVFPoseedor';

    if (isDAE) {
      this.headArrayModificado = this.headArray.filter((col: any) => col.FieldName !== 'campanaAsociada');
    } else if (isCVFPoseedor) {
      this.headArrayModificado = this.headArray.filter((col: any) =>
        col.FieldName !== 'fechaInicioCorrecion' &&
        col.FieldName !== 'fechaFinCorrecion'
      );
    } else if (isCVFGestor) {
      this.headArrayModificado = this.headArray.filter((col: any) =>
        col.FieldName !== 'fechaInicioCorrecion' &&
        col.FieldName !== 'fechaFinCorrecion' &&
        col.FieldName !== 'campanaAsociada'
      );
    } else {
      this.headArrayModificado = this.headArray;
    }
  }

  private getBackendFilter() {

    const getTrimmed = (controlName: string) => {
     const value = this.generateForm.get(controlName)?.value;
        return typeof value === 'string' ? value.trim() : value;
      };

    let backendFilter: CampanaFilterDTO = {
      id: getTrimmed('id'),
      tipo: this.generateForm.get('tipo')?.value?.id,
      anio: this.generateForm.get('anio')?.value,
      descripcion: this.generateForm.get('descripcion')?.value
    };

    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const orden = this.generateForm.get('orden')?.value;
    const tipoOrden = this.generateForm.get('tipoOrden')?.value;
    return { backendFilter, page, size: this.pageSize, orden, tipoOrden };
  }

  getClosed() {}

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.buscar();
  }

  action(element: any) {
    if (element.nameButton == 'view') {
      this.abrirModalCampania(element);
    } else if (element.nameButton == 'errors') {
      this.abrirModalCampaniaErrores(element);
    }
  }

  abrirModalCampaniaErrores(campania?: any): void {
    const dialogRef = this.dialog.open(DeclarationCampaignErrorsComponent, {
        width: '1250px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          campaniaId: campania?.id,
          tipo: campania?.tipo
        },
        disableClose: true,
      });
  }

  abrirModalCampania(campania?: any): void {

    let soloLectura: boolean = false;
    if (campania?.id) {
      soloLectura = true;
    }

      const dialogRef = this.dialog.open(DeclarationCampaignDialogComponent, {
        width: '950px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          campaniaId: campania?.id,
          soloLectura: soloLectura,
        },
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.buscar();
        }
      });
    }

  limpiar(): void {
    this.generateForm.reset();

    this.flagSearch = false;
    this.gridArray = [];
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.generateForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v) => v !== filtro.value);
        this.generateForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.generateForm.get(filtro.campo)?.reset();
    }

    this.pageNumber = 1;
    //this.buscar();
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const id = this.generateForm.get('id')?.value;
    if (id !== null && id !== undefined && id !== '') {
      filtros.push({ label: ` ${id}`, campo: 'id' });
    }

    const tipo = this.generateForm.get('tipo')?.value;
    if (tipo) {
      filtros.push({ label: ` ${tipo?.name ?? tipo?.id ?? String(tipo)}`, campo: 'tipo' });
    }

    const anio = this.generateForm.get('anio')?.value;
    if (anio) {
      filtros.push({ label: ` ${anio}`, campo: 'anio' });
    }

    const descripcion = this.generateForm.get('descripcion')?.value;
    if (descripcion) {
      filtros.push({ label: ` ${descripcion}`, campo: 'descripcion' });
    }
const ordenes = this.generateForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.generateForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }

    return filtros;
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.generateForm?.controls[controlName]?.hasError(errorName) &&
      this.generateForm?.controls[controlName]?.touched
    );
  }
  canViewResource(rol: string): boolean {
        return this.authService.hasCurrentUserRole(rol);
    } 
}
